import React from 'react';
import { colors } from 'styleguide';

import { IconProps } from './types';

const Angle = ({ size = 20, color = colors('neutral', 3), className }: IconProps) => (
  <svg
    className={className}
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7 9L10 12L13 9" stroke={color} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default Angle;
